import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'
import { pathOr } from 'ramda'

import useTranslate from '../../../../hooks/useTranslate'

import LineItem from '../LineItem'

import { getCustomerType, getInTermMonthlyBillAmount } from '../utils'

import { SingleLineItem } from '../styles'
import localeContext from '../../../../contexts/Locale'

const MobilityMonthlyBill = ({
  cart: {
    root: { customer }
  },
  dataTestId,
  isAuthenticated,
  totalPrice: { recurring }
}) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const translations = translate('priceSummary.paymentBreakdownWithMH.mobility')

  const monthlyBillAmount = () => {
    if (recurring.length > 0) {
      return getCustomerType(customer) === 'business'
        ? pathOr(0, [0, 'recurringBreakdowns', 0, 'subTotal'])(recurring)
        : getInTermMonthlyBillAmount(
            pathOr([{ subTotal: 0 }], [0, 'recurringBreakdowns'])(recurring),
            false
          )
    }
    return 0
  }

  return (
    <SingleLineItem>
      <LineItem
        text={translations.monthlyBill}
        cost={monthlyBillAmount()}
        lang={lang}
        bold
        amountBold
        annotationInline
        dataIdAttribute={`${dataTestId}-price-summary-mobility-monthlybill`}
        showTooltip={isAuthenticated}
      />
    </SingleLineItem>
  )
}

MobilityMonthlyBill.propTypes = {
  cart: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  totalPrice: PropTypes.object.isRequired
}

export default memo(MobilityMonthlyBill)
